export default [
  {
    name: "STUDIOS",
    link: "/studios"
  },
  {
    name: "APPRENTICES",
    link: "/apprentices"
  },
  {
    name: "MASTERS",
    link: "/masters"
  }
];
